module.exports = __webpack_public_path__ + "img/push.acea4c49.svg";